import GedChecklistRepository from '@/shared/http/repositories/business/gedchecklist'
import GedSubjectRepository from '@/shared/http/repositories/business/gedsubject'
import GedTagRepository from '@/shared/http/repositories/business/gedtag'
import GedTypeRepository from '@/shared/http/repositories/business/gedtype'
import folderPermission from '@/shared/utils/folderPermission'
import Roles from '@/shared/utils/roles'
import { loading } from '@/shared/utils/UIHelper'
import PermissionMixin from '@/store/module/permission/mixin'

const DocMixin = {
  mixins: [PermissionMixin],
  data () {
    return {
      roles: Roles
    }
  },
  methods: {
    hasFolderPermission (permission, folder) {
      if (!folder) return false

      const canSettings = this.hasRole(this.roles.RW_OPER_DOC_SETTINGS)

      const perm = (this.isAdministrator) ||
        (permission !== folderPermission.ADMIN && !folder.seguranca) ||
        (permission === folderPermission.ADMIN && canSettings && !folder.seguranca) ||
        // folder.contaAutorID === this.account.id ||
        (folder.gedPastaGrupos && folder.gedPastaGrupos.some(f => f.grupoID === this.account.grupoID &&
          (permission & f.permissao) > 0)) ||
        (folder.gedPastaContas && folder.gedPastaContas.some(f => f.contaID === this.account.id &&
          (permission & f.permissao) > 0))

      return perm
    },
    onLoadAllTypes () {
      loading.push()
      GedTypeRepository.GetAll()
        .then(response => {
          this.form.gedTipoID.options = this.onResultDropdown(response)
        })
        .catch(err => {
          console.log(err)
          this.onException(err)
        })
    },
    onLoadAllSubjects () {
      loading.push()
      GedSubjectRepository.GetAll()
        .then(response => {
          this.form.gedAssuntoID.options = this.onResultDropdown(response)
        })
        .catch(err => {
          console.log(err)
          this.onException(err)
        })
    },
    onLoadAllChecklists () {
      loading.push()
      GedChecklistRepository.GetAll()
        .then(response => {
          this.form.gedChecklistID.options = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch(err => {
          console.log(err)
          this.onException(err)
        })
    },
    onLoadAllTags () {
      loading.push()
      GedTagRepository.GetAll()
        .then(response => {
          this.form.gedTagID.options = this.onResultDropdown(response)
        })
        .catch(err => {
          console.log(err)
          this.onException(err)
        })
    }
  }
}

export default DocMixin



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/mixins/DocMixin.js